import React, { useState, useMemo } from 'react';
import { AxiosInstance } from 'axios';
import { QResourceContextType } from './types';

const QResourceContext = React.createContext<QResourceContextType | null>(null);

export const useQResourceContext = (): QResourceContextType => {
  const context = React.useContext(QResourceContext);
  if (!context) {
    throw new Error('useQResourceContext must be used within QResourceRoutes');
  }
  return context;
};

export const QResourceContextProvider: React.FC<{
  mtbeClient: AxiosInstance;
  qriClient: AxiosInstance;
  withTasks: boolean;
  children: React.ReactNode;
}> = ({ mtbeClient, qriClient, withTasks, children }) => {
  const [qri, setQri] = useState<string[]>([]);

  const value = useMemo<QResourceContextType>(
    () => ({
      mtbeClient,
      qriClient,
      withTasks,
      qri,
      setQri,
    }),
    [mtbeClient, qriClient, withTasks, qri],
  );

  return (
    <QResourceContext.Provider value={value}>
      {children}
    </QResourceContext.Provider>
  );
};
